
import moment from 'moment'
import { getBaseUrl } from '~/config/api'
import { api } from '~/config/api.js'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import { groupAlias } from '~/helpers/user'
import TextInput from '~/components/Registration/input/index.vue'

const DATE_FORMAT = 'MM/DD/YYYY'

export default {
  name: 'RegistrationStepTwo',
  components: {
    TextInput
  },
  mixins: [ui],
  props: {
    user: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      info: {
        doctorName: this.user.doctorName,
        doctorEmail: this.user.doctorEmail,
        userName: this.user.userName,
        userEmail: this.user.userEmail,
        licenseNumber: this.user.licenseNumber,
        state: this.user.state,
        licenseExpDate: this.user.licenseExpDate ? moment(this.user.licenseExpDate).format(DATE_FORMAT) : ''
      },
      validDoctorName: false,
      validDoctorEmail: false,
      validUserName: false,
      validUserEmail: false,
      validLicenseExpDate: false,
      externalError: '',
      userIsDoctor : true
    }
  },
  computed: {
    valid() {
      return this.validDoctorName && this.validDoctorEmail && this.validLicenseExpDate && (this.userIsDoctor || (this.validUserName && this.validUserEmail))
    }
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit('validation', v)
      },
      immediate: true
    }
  },
  methods: {
    groupAlias,
    async nextBtnClickHandler() {
      try {
        this.showFSLoader()

        const res = await this.$axios.post(`${getBaseUrl()}/api/${api.AUTH}/${api.CREATE_CONSUMER}`, {
          email: this.info.doctorEmail,
          userName: this.info.doctorName,
          extraEmail: this.info.userEmail,
          extraName: this.info.userName,
        })

        if (!res.data.doctorId) throw new Error('No doctorId')

        const {
          AccessToken: accessToken,
          RefreshToken: refreshToken
        } = res.data.tokenData
        if (!accessToken) throw new Error('No accessToken')
        if (!refreshToken) throw new Error('No refreshToken')

        await this.$auth.setUserToken(accessToken, refreshToken)

        await this.createPracticeLocation(res.data.doctorId)

        return this.info
      } catch (e) {
        console.error('onConfirm', e)

        this.externalError = e.response?.data?.error ?? 'Something went wrong'
        return false
      } finally {
        this.hideFSLoader()
      }
    },
    async createPracticeLocation(doctorId) {
      await this.$axios.post(`${api.PRACTICES}/${api.RELATION_WITH_PRACTICE_AND_USER}`, {
        data: {
          type: `${api.PRACTICES}`,
          attributes: {
            doctor_id: doctorId,
            practice_data: {
              country_id: 1,
              group_name: groupAlias(),
              license_number: this.info.licenseNumber,
              state: this.info.state,
              license_parameters: {
                valid: 1,
                expirationDate: moment(this.info.licenseExpDate).format(DATE_FORMAT)
              }
            }
          }
        }
      })
    }
  }
}
